export default __webpack_public_path__ + "static/media/wallart.14c07ed3.png";